import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, Button, App, Flex, Grid } from "antd";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { setCurrentRoute } from "../../../store/commonSlices/routeSlice";
import ReportDom from "../../../components/common/ReportDom";
import DebtorReceiptRecordTable from "./components/DebtorReceiptRecordTable";
import DebtorReceiptRecordFilters from "./components/DebtorReceiptRecordFilters";
import './style.css'
import { exportCollectionReportCsv } from "../SalesCollectionRecord/components/exportCollectionReportCsv";
import { selectAuthInfo } from "../../Auth/authSelectors";

const DebtorReceiptRecord = ({ location }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
 const authInfo  = useSelector(selectAuthInfo);
  const { list, receipts, filters } = useSelector((state) => state.collectionReport);

  // Set current route
//   useEffect(() => {
//     const pathname = location.pathname;
//     const routeName = pathname.split('/').filter(Boolean).pop() || 'home';
//     dispatch(setCurrentRoute(routeName));
//   }, [dispatch, location.pathname]);

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Customer Receipt Record",
    removeAfterPrint: true,
  });
const handleDownloadCsv = () => {
    exportCollectionReportCsv({
      list,
      receipts,
      filters,
      authInfo,
      title:    "Sales Paid & Collection Record",
      filename: "collection_report",
    });
  };

  const hasData = list.length > 0 || receipts.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button 
                type="text" 
                icon={<ArrowLeftOutlined />} 
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <span>Customer Receipt Record</span>
            </div>
          }
         extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <DebtorReceiptRecordFilters messageApi={message} />
        
        <Card className="shadow-md rounded-xl">
          <DebtorReceiptRecordTable />
        </Card>
      </App>
      
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Customer Receipt Record"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <DebtorReceiptRecordTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default DebtorReceiptRecord;